export default "__VITE_ASSET__wr$V4m96__"